<div class="table-section">
    <mat-card class="templates-card">    
        <div class="div">
            <div class="form-check form-switch">
                <input
                    class="form-check-input"
                    [ngClass]="template ? 'active-switch' : 'inactive-switch'"
                    type="checkbox"
                    role="switch"
                    [(ngModel)]="template"
                    (change)="onToggleChange()"
                />
            </div>
        </div>
    </mat-card>
  </div>
  